import { useState } from "react";

interface SharePanelProps {
  open: boolean;
  url: string;
  title: string;
  onClose: () => void;
}

const shareTargets = [
  { key: "weibo", label: "微博", icon: "ri-weibo-fill" },
  { key: "wechat", label: "微信", icon: "ri-wechat-fill" },
  { key: "qq", label: "QQ", icon: "ri-qq-fill" },
  { key: "link", label: "复制链接", icon: "ri-link" },
];

export default function SharePanel({ open, url, title, onClose }: SharePanelProps) {
  const [copied, setCopied] = useState(false);

  if (!open) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch {
      /* clipboard unavailable in some browsers */
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleTarget = (key: string) => {
    if (key === "link") {
      handleCopy();
      return;
    }
    handleCopy();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="relative w-full max-w-sm rounded-lg bg-background-50 p-5">
        <div className="flex items-center justify-between">
          <h3 className="text-base font-semibold text-foreground-950">分享「{title}」</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 hover:bg-background-100"
          >
            <i className="ri-close-line text-lg" />
          </button>
        </div>

        <p className="mt-3 break-all rounded-md bg-background-100 px-3 py-2 text-xs text-foreground-600">
          {url}
        </p>

        <div className="mt-4 grid grid-cols-4 gap-3">
          {shareTargets.map((t) => (
            <button
              key={t.key}
              type="button"
              onClick={() => handleTarget(t.key)}
              className="flex flex-col items-center gap-1.5 rounded-md py-2 text-xs text-foreground-600 transition-colors hover:bg-background-100"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary-100 text-primary-700">
                <i className={`${t.icon} text-lg`} />
              </span>
              {t.label}
            </button>
          ))}
        </div>

        {copied && (
          <p className="mt-4 flex items-center justify-center gap-1.5 rounded-md bg-secondary-50 px-3 py-2 text-xs text-secondary-900">
            <i className="ri-check-line" />
            链接已复制（演示分享面板）
          </p>
        )}
      </div>
    </div>
  );
}